import { useTranslation } from 'react-i18next';

import Button from 'components/button/Button';
import { RichTextEditorToolbarPluginProps } from 'components/editor/RichTextEditor.types';

interface TogglePreviewModeButtonProps {
  disabled: boolean;
  isPreviewModeEnabled: RichTextEditorToolbarPluginProps['isPreviewModeEnabled'];
  setIsPreviewModeEnabled: RichTextEditorToolbarPluginProps['setIsPreviewModeEnabled'];
  toolbarSettings: RichTextEditorToolbarPluginProps['toolbarSettings'];
}

const TogglePreviewModeButton = ({
  disabled,
  isPreviewModeEnabled,
  setIsPreviewModeEnabled,
  toolbarSettings,
}: TogglePreviewModeButtonProps) => {
  const { t } = useTranslation();
  const { features } = toolbarSettings;

  if (!features?.preview) {
    return null;
  }

  const { onEnterPreviewMode, onExitPreviewMode } = features.preview;

  const handleOnClick = () => {
    if (isPreviewModeEnabled) {
      setIsPreviewModeEnabled(false);
      onExitPreviewMode?.();
    } else {
      setIsPreviewModeEnabled(true);
      onEnterPreviewMode?.();
    }
  };

  return (
    <Button
      className={`toolbar-item ${isPreviewModeEnabled ? 'active' : ''}`}
      data-testid="toolbar-button-preview"
      disabled={disabled}
      onClick={handleOnClick}
    >
      {t('form.editor.buttons.preview')}
    </Button>
  );
};

export default TogglePreviewModeButton;
